import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.model.isReady}}\r\n    <ApplicationView @id=\"application-view\" />\r\n{{/if}}",{ moduleName: "adcdriver/templates/index.hbs" })